import { Container } from '../../common/container/Container'


export type DirectTestingContainerConfig = {
    moduleFullUrlDirectTesting: string
}

export type DirectTestingProps = {
    DirectTestingContainer: Container
    config: DirectTestingContainerConfig
}

export const DIRECT_TESTING_API_KEY = Symbol('DIRECT_TESTING_API_KEY')
export const DIRECT_TESTING_SERVICE_KEY = Symbol('DIRECT_TESTING_SERVICE_KEY')
export const DIRECT_TESTING_MODULE = Symbol('DIRECT_TESTING_MODULE')